/**
 * Supabase Client Configuration
 */
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// Validate environment variables
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Missing Supabase environment variables!')
  console.error('URL:', supabaseUrl || '(empty)')
  console.error('Key:', supabaseAnonKey ? '(set)' : '(empty)')
  console.error('')
  console.error('🔧 SOLUÇÃO - Configure no Vercel:')
  console.error('1. https://vercel.com/inosx/nex-store/settings/environment-variables')
  console.error('2. Adicione:')
  console.error('   NEXT_PUBLIC_SUPABASE_URL = https://auqfubbpxjzuzzqfazdp.supabase.co')
  console.error('   NEXT_PUBLIC_SUPABASE_ANON_KEY = sua-anon-key')
  console.error('3. Redeploy')
  throw new Error('Missing Supabase configuration. Check console for details.')
}

export const supabase = createClient(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true
    }
  }
)

/**
 * Helper para chamadas de API
 */
export const apiCall = async (endpoint, options = {}) => {
  const { data: { session } } = await supabase.auth.getSession()
  
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers
  }

  if (session?.access_token) {
    headers['Authorization'] = `Bearer ${session.access_token}`
  }

  const response = await fetch(`${supabaseUrl}/rest/v1/${endpoint}`, {
    ...options,
    headers
  })

  if (!response.ok) {
    throw new Error(`API Error: ${response.statusText}`)
  }

  return response.json()
}

/**
 * Helper para Edge Functions
 */
export const callEdgeFunction = async (functionName, body = {}) => {
  const { data: { session } } = await supabase.auth.getSession()
  
  const headers = {
    'Content-Type': 'application/json'
  }

  if (session?.access_token) {
    headers['Authorization'] = `Bearer ${session.access_token}`
  }

  const response = await supabase.functions.invoke(functionName, {
    body,
    headers
  })

  if (response.error) {
    throw new Error(response.error.message)
  }

  return response.data
}
